import { useContext } from 'react';
import { SessionContext } from '../../../../js/app/contexts/SessionContext';

export function StaffHome() {
  const { logout } = useContext(SessionContext);

  return (
    <div className="tw:p-4 tw:max-w-screen-lg tw:mx-auto tw:w-full">
      <h1 className="tw:text-3xl tw:font-bold tw:mb-6">Staff Home</h1>
      <div className="tw:bg-white tw:rounded-xl tw:p-6 tw:border tw:border-gray-200">
        <p className="tw:text-gray-700">Welcome to the staff portal.</p>
        <button onClick={() => logout?.()}>Logout</button>
      </div>
    </div>
  );
}

export default StaffHome;
